module.exports = __webpack_public_path__ + "static/media/1015182.21222c12.jpg";